import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Http from "../../Common/Http";
import IsLogin from "../../Common/IsLogin";
import { LoaderComponent } from "../../Common/LoaderComponent";

const View = () => {
  const { id } = useParams();
  const [receiveData, setReceiveData] = useState({});

  const fetchData = () => {
    Http.get("/crm/" + id).then((res) => {
      setReceiveData(res.data);
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const items = receiveData.list ? receiveData.list : [];
  const distributor = receiveData.order ? receiveData.order.distributor : null;

  // The legacy screen showed "Factory" wherever the Central Warehouse solved a ticket.
  const solverName = () => {
    if (!receiveData.solver) return "";
    return receiveData.solver.name === "Central Warehouse" ? "Factory" : receiveData.solver.name;
  };

  // Invoice tickets point at an order, chalan tickets at a depo transfer.
  const referenceNo = () => {
    if (receiveData.ticket_for === "Invoice") return receiveData.order ? receiveData.order.receipt_no : "";
    return receiveData.depo_transfer ? receiveData.depo_transfer.receipt_no : "";
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent />
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Ticket View</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <div className="row">
              <div className="col-md-12">
                <table className="table" width="100%">
                  <tbody>
                    <tr>
                      <td width="18%">
                        <strong>Ticket No</strong>
                        <br />
                        <strong>Ticket for</strong>
                        <br />
                        <strong>{receiveData.ticket_for === "Invoice" ? "Invoice Number" : "Chalan Number"}</strong>
                        <br />
                        {distributor && (
                          <>
                            <strong>Distributor Name</strong>
                            <br />
                            <strong>Distributor ID</strong>
                            <br />
                          </>
                        )}
                        <strong>Calling No</strong>
                        <br />
                        <strong>Complain Type</strong>
                      </td>
                      <td width="42%">
                        : {receiveData.ticket_no} <br />: {receiveData.ticket_for} <br />: {referenceNo()} <br />
                        {distributor && (
                          <>
                            : {distributor.name} <br />: {distributor.code} <br />
                          </>
                        )}
                        : {receiveData.calling_number} <br />: {receiveData.complain_type}
                      </td>
                      <td width="35%" align="right">
                        <strong>Date</strong>: {receiveData.date} <br />
                        <strong>Time</strong>: {receiveData.time} <br />
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="3">
                        <b>Message: </b>
                        <br />
                        {receiveData.complain_message}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <table className="table table-bordered table-sm" width="100%" style={{ fontSize: "12px" }}>
                  <tbody>
                    <tr style={{ backgroundColor: "#f1f1f1" }}>
                      <td style={{ textAlign: "center" }}>Sl.</td>
                      <td style={{ textAlign: "center" }}>Product Name</td>
                      <td style={{ textAlign: "center" }}>Qty</td>
                    </tr>
                    {Array.from(items).map((item, index) => (
                      <tr style={{ fontSize: "12px" }} key={item.id}>
                        <td>{index + 1}</td>
                        <td>{item.product ? item.product.name : ""}</td>
                        <td>{item.qty}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {receiveData.solver_id && (
              <div className="row">
                <div className="col-md-12">
                  <table className="table table-bordered table-sm" width="100%" style={{ fontSize: "12px" }}>
                    <tbody>
                      <tr style={{ backgroundColor: "#f1f1f1" }}>
                        <th style={{ textAlign: "center" }}>Solved By</th>
                        <th style={{ textAlign: "center" }}>Date</th>
                        <th style={{ textAlign: "center" }}>Remarks</th>
                      </tr>
                      <tr style={{ fontSize: "12px" }}>
                        <td>{solverName()}</td>
                        <td>{receiveData.solution_date}</td>
                        <td>{receiveData.solution_message}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default View;
